/* Bug #670
@author Midhila Velayudhan
@Date 13 Dec 2021
Toggle left side Icon in accordion  
*/
import React from "react";
import { AccordionContext } from "react-bootstrap";

function CustomToggle({ children, eventKey}) {
    const currentEventKey = React.useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;
  
  return (

     <i className={isCurrentEventKey?"fas fa-chevron-down mr-2 float-right" : "fas fa-chevron-right mr-2 float-right" }></i> 
    );
  }
  export default CustomToggle;